<template>
	<svg :style="{ width: cssUnit2Rem(width), height: cssUnit2Rem(height), color: color }">
		<use :xlink:href="prefix + name" :fill="color"></use>
	</svg>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue';
import { cssUnit2Rem } from '../utils/tools';

const props = defineProps({
	//xlink:href属性值的前缀
	prefix: {
		type: String,
		default: '#icon-'
	},
	//svg矢量图的名字
	name: String,
	//svg图标的颜色
	color: {
		type: String,
		default: ''
	},
	//svg宽度
	width: {
		type: String,
		default: '.4267rem'
	},
	//svg高度
	height: {
		type: String,
		default: '.4267rem'
	}
});
const { prefix, name, color, width, height } = toRefs(props);
</script>
<style scoped></style>
